import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

const styles = {
  icon: {
    width: '100%',
    height: '100%',
  },
};

function Icon(props: { [x: string]: any; src: any; alt: any; classes: any; className: any }) {
  const { src, alt, classes, className, ...others } = props;
  const iconClassName = classNames({
    [classes.icon]: true,
    [className]: className !== undefined,
  });
  return <img src={src} alt={alt} className={iconClassName} {...others} />;
}

export default withStyles(styles)(Icon);
